import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'



const HD = [


    {
        "Name": "Dr.Hiranmayee Vedam",
        "NameLink": "https://iittp.ac.in/people/faculty/others#",
        "Position": "Senior Project Advisor, Entrepreneurship, Innovation & Incubation ",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Purdue University, West Lafayette, USA",
        "AreasofInterest": "Product Management, New Business Development,Technology & Market Intelligence, Advanced Materials,    Competitive Analysis, Business Strategy,  Technology Development Roadmaps",
        "TeachingCourse": "ID5103 - Innovation and Entrepreneurship",
        "Phone": "",
        "Email": " hiran@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/HiranVedam.jpg"
    }
    

    // {
    //     "Name": "Dr. Reetesh Kumar Gangwar",
    //     "NameLink": "https://iittp.ac.in/people/faculty/others#",
    //     "Position": "Senior Project Advisor, Entrepreneurship, Innovation & Incubation ",
    //     "Category": "Head of the Department",
    //     "Degree": "Ph.D - Purdue University, West Lafayette, USA ",
    //     "AreasofInterest": "Product Management, New Business Development,Technology & Market Intelligence, Advanced Materials,    Competitive Analysis, Business Strategy,  Technology Development Roadmaps",
    //     "TeachingCourse": "ID5103 - Innovation and Entrepreneurship",
    //     "Phone": "",
    //     "Email": " hiran@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/HiranVedam.jpg"
    // }
]
const Faculty = [


    {
        "Name": "Dr. Ambrish Saxena",
        "NameLink": "#",
        "Degree": "Ph.D - Rudolf Virchow Center for Experimental Biomedicine, University of Wurzburg, Germany.",
        "AreasofInterest": "Bioprocessing, Biotechnology, Biopharmaceutical Discovery and Development",
        "Phone": "+91 - 9687119036",
        "Email": "ambrish@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Staff/Ambrish.png"
    },
    {
        "Name": "Dr. Mousumi Banerjee",
        "NameLink": "#",
        "Degree": "Ph.D - IISc, Bangalore, India",
        "AreasofInterest": "Will be Updated Soon",
        "Email": "mousumi.banerjee79@gmail.com",
        "Image": "https://files.iittp.ac.in/images/demo/iit/benerjee.jpeg"
    }


]



function Main() {


        // useEffect(() => {
        //     document.title = 'IIT Tirupati - Other Guest Faculty';
        // }, []);

    return (
        <>
           <Header />
           <title>IIT Tirupati - Other Guest Faculty </title>          
            <Breadcrumb title="Home" subtitle="OTHER GUEST FACULTIES" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>OTHER GUEST FACULTIES</h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={10} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Entrepreneurship, Innovation & Incubation</h3>
                                {HD.map((Faculty, index) => (
                                    <div key={index} className="col-xl-6 col-md-6">

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to="#">
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p className="text-dark fw-bold"> {Faculty.Position}</p>
                                                    
                                                    <p className="text-dark">  <i className='fw-bold text-dark fal fa-graduation-cap me-2' /> {Faculty.Degree}   </p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>  {Faculty.AreasofInterest}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'>Teaching Course :</span> {Faculty.TeachingCourse}</p>
                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>LifeSciences</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p className="text-dark"> {Faculty.Position}</p>
                                                    <p className="text-dark">  <i className='fw-bold text-dark fal fa-graduation-cap me-2' /> {Faculty.Degree}   </p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main